import {
    AUCTION_PAGE_ROUTE,
    CAMPAIGN_CREATE_URL,
    CAMPAIGN_QUICK_CREATE_URL,
    CREATE_MENU_PAGE_ROUTE,
    TOP_UP_PAGE_ROUTE,
} from 'utils/constants/app';
import { BANNER_ID_URL_FIELD_NAME } from 'utils/constants/banner';
import { CAMPAIGN_ID_URL_FIELD_NAME } from 'utils/constants/campaign';

export enum Methods {
    Translations = '/api/v1/all_users/translations',
    Settings = '/api/v1/all_users/settings',
    User = '/api/v1/user',
}

export const READ_ONLY_ROUTES = [
    CREATE_MENU_PAGE_ROUTE,
    CAMPAIGN_CREATE_URL,
    CAMPAIGN_QUICK_CREATE_URL,
    AUCTION_PAGE_ROUTE,
    `/new/campaign/:${CAMPAIGN_ID_URL_FIELD_NAME}/`,
    `/new/campaign/:${CAMPAIGN_ID_URL_FIELD_NAME}/banner/:${BANNER_ID_URL_FIELD_NAME}/copy`,
    `/new/campaign/:${CAMPAIGN_ID_URL_FIELD_NAME}/banner/`,
    `/new/campaign/:${CAMPAIGN_ID_URL_FIELD_NAME}/banner/:${BANNER_ID_URL_FIELD_NAME}/`,
    TOP_UP_PAGE_ROUTE,
];
